import * as React from 'react';
import $ from 'jquery';
import { AppSessionContext } from '../../Services/Services.Primary/SessionContext/AppSessionContext';
import TelemetryService from '../../Services/Services.Primary/Telemetry/TelemetryService';
import LocalizationService from '../../Services/Services.Secondary/Localization/LocalizationService';
import { SupportTopic } from './Models/SupportTopic';
import CollapsingElementBox from './CollapsingElementBox';
import { Constants } from './Constants';
import { Guid } from './Guid';
import InfoView from './InfoView';
import { FileInfo, Note, ServiceRequest } from './Models/ServiceRequest';
import CountryInformationService from './Services/CountryInformationService';
import { Helper } from './Utilities/Helper';

let resx = LocalizationService.getInstance();
let Constant = Constants.getInstance();
let tracingService = TelemetryService.getInstance();
let isEmptyOrSpaces = Helper.isEmptyOrSpaces;
let countryInformationService = CountryInformationService.getInstance();

//Resource strings
let customer = resx.getLocalizedResource('AllView_Customer');
let opened = resx.getLocalizedResource('AllView_Opened');
let modifiedDate = resx.getLocalizedResource('AllView_Modified_Date');
let description = resx.getLocalizedResource('AllView_Description');
let submit = resx.getLocalizedResource('AllView_SubmitButton');
let cancel = resx.getLocalizedResource('AllView_CancelButton');
let status = resx.getLocalizedResource('SubscriptionView_Status');
let AddedByText = resx.getLocalizedResource('ServiceRequests_Added_By');
let AddedText = resx.getLocalizedResource('ServiceRequests_Added');
let onText = resx.getLocalizedResource('ServiceRequests_On');
let SelectARegion_text = resx.getLocalizedResource('SelectARegion_text');
let textAreaLabel = resx.getLocalizedResource('ServiceRequest_TextArea_Label');
let attachmentsLabel = resx.getLocalizedResource('AllView_Attachments');
let DragDropText = resx.getLocalizedResource('DragDropText');
let RequestInfoTitle_text = resx.getLocalizedResource('ServiceRequest_SubTitle');
let TicketId_text = resx.getLocalizedResource('TicketId_text');
let RequestTitle_text = resx.getLocalizedResource('RequestTitle_text');
let IssueType_text = resx.getLocalizedResource('IssueType_text');
let RequestActivityTitle_text = resx.getLocalizedResource('RequestActivityTitle_text');
let AddNoteError_text = resx.getLocalizedResource('AddNoteError_text');
let Expand_text = resx.getLocalizedResource('Expand_text');
let Collapse_text = resx.getLocalizedResource('Collapse_text');
let PhoneSupportGetHelp_text = resx.getLocalizedResource('PhoneSupportGetHelp_text');
let PhoneSupport_text = resx.getLocalizedResource('PhoneSupport_text');
let PhoneNumbers_text = resx.getLocalizedResource('PhoneNumbers_text');
let CannotChangeStatus_text = resx.getLocalizedResource('CannotChangeStatus_text');
let Attachments_subtext = resx.getLocalizedResource('Attachments_subtext');
let Attachments_text = resx.getLocalizedResource('Attachments_text');

interface ICountryToPhoneNumberDictionary {
  [key: string]: string[];
}

interface ILocaleToCountryDictionary {
  [key: string]: string;
}

const localToCountryList = countryInformationService.getLocaleToCountryDictionary() as ILocaleToCountryDictionary;
const phoneNumbers = countryInformationService.getCountryToPhoneNumberDictionary() as ICountryToPhoneNumberDictionary;
const countryLocalizedList = countryInformationService.getCountryLocalizedList();

interface ITicketDetailsState {
  attachments: FileInfo[];
  showUploadProgress: boolean;
  showAddNoteError: boolean;
  attachmentAdded: boolean;
  attachFileErrorMessage: string;
  form: IFormModal;
  showPhoneNumber: boolean;
  selectedCountryId: string;
  initialStatus: string;
  canChangeStatus: boolean;
}
export interface IFormModal {
  status: string;
  newNote: { text: string };
}
interface ITicketDetailsProps {
  serviceRequest: ServiceRequest | null;
  workspaceId: string;
  customerOrganizationId: string;
  statusOptions: any;
  isPartnerTicket: boolean;
  isRaveTicket: boolean;
  isAzureTicket: () => boolean;
  updateServiceRequest: (serviceRequest: ServiceRequest) => void;
  cancelHandler: () => void;
  templateData?: any;
  isPublicRoute?: boolean;
  titleDiv?: any;
  isSupportPublicRoute?: boolean;
  confirmationTextBox?: any;
  okButtonText?: string;
  issueType?: SupportTopic;
  ticketDetailsBanner: any;
}

declare global {
  interface Window {
    updateBreadcrumbs: void;
  }
  interface Window {
    hideTaskMenuItemGroup: void;
  }
  interface Window {
    showTaskMenuItemGroup: void;
  }
}
export default class TicketDetails extends React.Component<ITicketDetailsProps, ITicketDetailsState> {
  private workspaceId: string = '';
  private resumableInitialized = false;
  constructor(props: ITicketDetailsProps) {
    super(props);
    this.state = {
      attachments: [],
      showUploadProgress: false,
      showAddNoteError: false,
      attachmentAdded: false,
      attachFileErrorMessage: '',
      form: {
        status: this.props.serviceRequest?.status ?? '',
        newNote: {
          text: '',
        },
      },
      showPhoneNumber: false,
      selectedCountryId: '',
      initialStatus: this.props.serviceRequest?.status ?? '',
      canChangeStatus: false,
    };
  }

  componentDidUpdate(prevProps: any, prevState: any, snapshot: any) {
    $('#dragdrop').on('dragover', function (e: any) {
      e.preventDefault();
      e.stopPropagation();
      $('#dragdrop').addClass('dragged');
    });
    $('#dragdrop').on('dragenter', function (e: any) {
      e.preventDefault();
      e.stopPropagation();
      $('#dragdrop').addClass('dragged');
    });
    $('#dragdrop').on('dragleave', function (e: any) {
      e.preventDefault();
      e.stopPropagation();
      $('#dragdrop').removeClass('dragged');
    });

    $('#dragdrop').on('drop', function (e: any) {
      e.preventDefault();
      $('#dragdrop').removeClass('dragged');
    });
  }

  private getLoader = (showProgress: boolean) => {
    return showProgress ? <div className="upload-progress" /> : null;
  };
  public handleOnChange(e: React.FormEvent<EventTarget>) {
    let target = e.target as HTMLInputElement;
    let store = this.state.form;
    let newNote = store.newNote;

    if (target.name == 'note') {
      newNote.text = target.value;
    }

    if (!this.props.isRaveTicket) {
      if (target.name == 'status') {
        store.status = target.value;
      }
    }
    this.setState({ form: store });
  }
  public updateServiceRequestHandler = (e: React.FormEvent<EventTarget>) => {
    let serviceRequest: ServiceRequest | null = this.props.serviceRequest;
    let store = this.state.form;
    if (serviceRequest) {
      if (!this.props.isRaveTicket) {
        serviceRequest.status = store.status;
      }
      serviceRequest.newNote = store.newNote as Note;
      let dtmLink = Constant.DtmUrl + this.workspaceId;
      let fileLinks: FileInfo[] = new Array<FileInfo>();
      let attachments = this.state.attachments;
      if (attachments && attachments.length > 0) {
        for (let attachment of attachments) {
          let fileLink: FileInfo = {};
          fileLink.comment = dtmLink;
          fileLink.fileNameWithoutExtension = attachment.fileNameWithoutExtension;
          fileLink.fileSize = attachment.fileSize;
          fileLink.id = Guid.newGuid();
          fileLink.location = dtmLink;
          fileLinks.push(fileLink);
        }
      }
      serviceRequest.fileLinks = fileLinks;

      var message = {
        newAttachment: this.state.attachmentAdded,
        newNote: !Helper.isEmptyOrSpaces(serviceRequest.newNote.text),
        existingStatus: this.state.initialStatus,
        updatedStatus: serviceRequest.status,
        serviceRequestId: serviceRequest.id,
        supportTopicId: serviceRequest.supportTopicId,
        tenantId: serviceRequest.organization?.id,
      };

      tracingService.traceEvent(Constant.actionTypes.serviceRequestUpdate, message);
      this.props.updateServiceRequest(serviceRequest);
    }
  };

  /* Helper Methods */

  public getFullLocalTime(date: Date, locale: string) {
    return date.toLocaleString(locale, { timeZoneName: 'short', timeZone: 'UTC' });
  }
  public displayTime(date: any) {
    if (date) {
      return this.getFullLocalTime(new Date(date), AppSessionContext.getInstance().Locale);
    } else {
      return '';
    }
  }
  private getFilesInfo = (files: any[]) => {
    let filesInfo: string[] = new Array();
    for (let fileData of files) {
      filesInfo.push(fileData.file.name + ' ' + fileData.file.type);
    }
    return filesInfo;
  };

  private isSubmitDisabled = () => {
    let maxDescriptionLength = Helper.isCosmicTicket(
      this.props.issueType ?? {
        id: '',
        name: '',
        description: '',
        subtopics: [],
        categories: [],
        metadata: {
          authenticationStep: [],
          allowTicketCreationInPC: [],
          ticketingSystem: [],
          allowGuestTicketCreationInPC: [],
          searchTags: [],
          workspace: [],
          workspaceCategory: [],
          wayfinderModelId: [],
          partCConnectorPaths: [],
          enabledSupportOptionsInPC: [],
          categories: [],
          categoriesLevel2: [],
          seamId: [],
        },
      }
    )
      ? Constant.MaxDescriptionLength.cosmic
      : Constant.MaxDescriptionLength.nonCosmic;
    return (
      (isEmptyOrSpaces(this.state.form.newNote.text) || this.state.form.newNote.text.length > maxDescriptionLength) &&
      ((this.state.form.status === this.props.serviceRequest?.status && !this.state.attachmentAdded) ||
        this.props.isRaveTicket)
    );
  };

  private isConfirmationPage = () => {
    return this.props.confirmationTextBox != null;
  };

  private togglePhoneNumber = () => {
    let eventName = this.state.showPhoneNumber
      ? Constant.actionTypes.phoneSupportCollapse
      : Constant.actionTypes.phoneSupportExpand;

    tracingService.traceEvent(eventName);
    this.setState({ showPhoneNumber: !this.state.showPhoneNumber });
  };

  private handleCountryChange = (event: React.FormEvent<EventTarget>) => {
    let target = event.target as HTMLInputElement;
    this.setState({ selectedCountryId: target.value });
  };

  private isAttachmentEmpty = () => {
    return !(
      this.state.attachments &&
      this.state.attachments.length > 0 &&
      !(
        this.state.attachments.length === 1 &&
        this.state.attachments[0].fileNameWithoutExtension &&
        this.state.attachments[0].fileNameWithoutExtension.indexOf('ScopedTemplateData') != -1
      )
    );
  };

  /**
   * Considerations:
   * - Leap Year
   * - Day light savings time
   * - Time zones
   *
   * Specific 30 days closed based test Cases:
   *   // < 30 days
   *   //lastClosedDate = new Date(today.getDate() - 29);
   *   //lastClosedDate == 30 days
   *   //lastClosedDate = priorDate;
   *   // > 30 days
   *   lastClosedDate = new Date(today.getDate() - 31);
   *
   * Example dates for leap and non-leap year
   * - Leap: "March 01, 2020 11:20:25"
   * - Non-Leap: "March 01, 2021 11:20:25"
   *
   * @param serviceRequest
   */
  private canChangeStatus = (serviceRequest: ServiceRequest) => {
    if (this.isTempTicket(serviceRequest)) return;

    if (!this.isTicketClosed(serviceRequest)) {
      this.setState({ canChangeStatus: true });
      return;
    }
    let priorDate = Date.now() - 30 * Constant.DayToMilliSecondsFactor.factor;
    let evalDate =
      serviceRequest.lastClosedDate == null ? serviceRequest.lastModifiedDate : serviceRequest.lastClosedDate;
    let lastClosedDate = new Date(evalDate ?? '');
    let changeStatus = lastClosedDate.getTime() >= priorDate;
    this.setState({ canChangeStatus: changeStatus });
  };

  private isTempTicket = (serviceRequest: ServiceRequest) => {
    return serviceRequest.id && serviceRequest.id.indexOf('tmp-') === 0;
  };

  private displayMessageCannotChangeStatus() {
    if (this.state.canChangeStatus || this.isTempTicket !== null) {
      return;
    }

    return (
      <div className="row" style={{ paddingBottom: '15px' }}>
        <div className="col-xs-8">
          <p></p>
        </div>
        <div className="col-xs-15">
          <table>
            <tbody>
              <tr>
                <td style={{ verticalAlign: 'top' }}>
                  <div style={{ paddingTop: '4px' }} className="win-icon-composite win-icon-size-xs">
                    <span
                      style={{ paddingTop: '4px' }}
                      className="win-icon win-icon-TaskStateCircleFull win-icon-size-xs win-color-fg-blue"
                    ></span>
                    <span
                      style={{ paddingLeft: '3px', paddingTop: '8px' }}
                      className="win-icon win-icon-Info2 infoIcon2IconSize win-color-fg-primary color-alt"
                    ></span>
                  </div>
                </td>
                <td style={{ verticalAlign: 'top', textAlign: 'left' }}>
                  <div className="col-xs-20" style={{ verticalAlign: 'top', paddingLeft: '20px', paddingTop: '0px' }}>
                    <p>{CannotChangeStatus_text}</p>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  private isTicketClosed(serviceRequest: ServiceRequest) {
    return serviceRequest.status === Constant.TicketStatus.closed;
  }

  private displayQuestionAnswer(answers: string[], type: string) {
    if (type !== 'object') {
      return answers;
    }

    let rv = '';
    answers.forEach(answer => {
      rv += answer + ', ';
    });
    return rv.substring(0, rv.length - 2);
  }

  public render() {
    let { serviceRequest, statusOptions, isPartnerTicket, isRaveTicket, isAzureTicket, templateData } = this.props;
    let phoneSupportCard = null;
    if (
      this.props.issueType &&
      this.props.issueType.metadata &&
      this.props.issueType.metadata.enabledSupportOptionsInPC &&
      this.props.issueType.metadata.enabledSupportOptionsInPC.indexOf(Constant.enabledSupportOptionsInPC.phone) != -1
    ) {
      let phoneDiv = null;
      if (this.state.showPhoneNumber) {
        let countryId = !Helper.isEmptyOrSpaces(this.state.selectedCountryId)
          ? this.state.selectedCountryId
          : localToCountryList[AppSessionContext.getInstance().Locale.toLowerCase()];
        let phoneObject = phoneNumbers[countryId];
        let countryDropdownOptions: any[] = [];
        Object.keys(phoneNumbers).forEach(function (key) {
          countryDropdownOptions.push(
            <option
              value={key}
              selected={countryId === key}
              label={countryLocalizedList[key]}
              data-toggle="tooltip"
              title={countryLocalizedList[key]}
            >
              {countryLocalizedList[key]}
            </option>
          );
        });
        phoneDiv = (
          <div className="col-xs-24">
            <div className="row">
              <div className="col-xs-16">
                <h3 style={{ fontSize: '18px', fontWeight: 800 }}>{PhoneSupport_text}</h3>
              </div>
              <div className="col-xs-8">
                <span className="cursorpointer">
                  <button
                    data-toggle="tab"
                    style={{
                      paddingTop: '0px',
                      paddingLeft: '24px',
                      paddingRight: '24px',
                      textDecoration: 'none',
                      display: 'inline-block',
                      outline: 0,
                    }}
                    className="generalLink displayView btn-link floatRight phoneSupportExpand"
                    onClick={this.togglePhoneNumber}
                  >
                    <span>{Collapse_text} </span>
                    <span className="win-icon win-icon-ChevronUp phoneSupportChevron" aria-hidden="true"></span>
                  </button>
                </span>
              </div>
            </div>
            <div style={{ paddingBottom: '15px' }}>{PhoneSupportGetHelp_text}</div>
            <div className="row" style={{ paddingBottom: '15px' }}>
              <div className="col-xs-8">
                <p className="text-small-opacity">{SelectARegion_text}: </p>
              </div>
              <div className="col-xs-16">
                <div className="dropdown floatLeft" style={{ width: '270px' }}>
                  <select
                    className="form-control ticket-field"
                    onChange={this.handleCountryChange}
                    onBlur={this.handleCountryChange}
                    data-toggle="tooltip"
                    title={countryLocalizedList[countryId]}
                  >
                    {countryDropdownOptions}
                  </select>
                  <span className="icon-win-down-arrow-country dev-icon"></span>
                </div>
              </div>
            </div>
            <div className="row" style={{ paddingBottom: '15px' }}>
              <div className="col-xs-8">
                <p className="text-small-opacity">{PhoneNumbers_text}</p>
              </div>
              <div className="col-xs-16">
                {phoneObject.map((phoneNumber: string) => (
                  <div>{phoneNumber}</div>
                ))}
              </div>
            </div>
          </div>
        );
      } else {
        phoneDiv = (
          <div className="col-xs-24">
            <div className="row">
              <div className="col-xs-16">
                <h3 style={{ fontSize: '18px', fontWeight: 800 }}>{PhoneSupport_text}</h3>
              </div>
              <div className="col-xs-8">
                <span className="cursorpointer">
                  <button
                    data-toggle="tab"
                    style={{
                      paddingTop: '0px',
                      paddingLeft: '24px',
                      paddingRight: '24px',
                      textDecoration: 'none',
                      display: 'inline-block',
                    }}
                    className="generalLink displayView btn-link floatRight phoneSupportExpand"
                    onClick={this.togglePhoneNumber}
                  >
                    <span>{Expand_text}</span>
                    <span className="win-icon win-icon-ChevronDown phoneSupportChevron" aria-hidden="true"></span>
                  </button>
                </span>
              </div>
            </div>
          </div>
        );
      }
      phoneSupportCard = (
        <div className="flexShrink0">
          <InfoView>
            <div style={{ paddingTop: '15px', paddingBottom: '15px', paddingLeft: '24px', paddingRight: '24px' }}>
              <div className="row">{phoneDiv}</div>
            </div>
          </InfoView>
        </div>
      );
    }

    return (
      serviceRequest && (
        <div>
          {this.props.ticketDetailsBanner}
          {this.props.confirmationTextBox}
          <div className="flexShrink0">
            <InfoView>
              <div style={{ paddingTop: '15px', paddingBottom: '15px', paddingLeft: '24px', paddingRight: '24px' }}>
                <div className="row" style={{ paddingBottom: '15px' }}>
                  <div className="col-xs-24">
                    <h2 style={{ fontSize: '18px', fontWeight: 800 }}>{RequestInfoTitle_text}</h2>
                  </div>
                </div>
                <div className="row" style={{ paddingBottom: '15px' }}>
                  <div className="col-xs-8">
                    <p className="text-small-opacity">{RequestTitle_text}</p>
                  </div>
                  <div className="col-xs-16">
                    <p>
                      <strong>{serviceRequest != null ? serviceRequest.title : ''}</strong>
                    </p>
                  </div>
                </div>
                <div className="row" style={{ paddingBottom: '15px' }}>
                  <div className="col-xs-8">
                    <p className="text-small-opacity">{TicketId_text}</p>
                  </div>
                  <div className="col-xs-16">
                    <p>{serviceRequest != null ? serviceRequest.id : ''}</p>
                  </div>
                </div>
                <div className="row" style={{ paddingBottom: '15px' }}>
                  <div className="col-xs-8">
                    <p className="text-small-opacity">{status}</p>
                  </div>
                  {(() => {
                    if (!isRaveTicket && !this.isConfirmationPage()) {
                      return (
                        <div className="col-xs-5">
                          <div className="combobox">
                            <select
                              className="form-control"
                              name="status"
                              aria-label={status}
                              id="Status"
                              disabled={!this.state.canChangeStatus}
                              onChange={event => this.handleOnChange(event)}
                            >
                              {statusOptions &&
                                statusOptions.map((option: any, index: any) => (
                                  <option value={option.id} selected={option.selected} aria-label={option.name}>
                                    {option.name}{' '}
                                  </option>
                                ))}
                            </select>
                          </div>
                        </div>
                      );
                    } else {
                      return (
                        <div className="col-xs-8">
                          <span className="text-body">
                            {resx.getLocalizedResource(
                              'AllView_' + (this.isConfirmationPage() ? 'open' : serviceRequest.status?.toLowerCase())
                            )}{' '}
                          </span>
                        </div>
                      );
                    }
                  })()}
                </div>
                <div>{this.displayMessageCannotChangeStatus()}</div>

                {!isPartnerTicket && (
                  <div className="row" style={{ paddingBottom: '15px' }}>
                    <div className="col-xs-8">
                      <p className="text-small-opacity">{customer} </p>
                    </div>
                    <div className="col-xs-16">
                      <p>{serviceRequest.organization?.name} </p>
                    </div>
                  </div>
                )}
                <div className="row" style={{ paddingBottom: '15px' }}>
                  <div className="col-xs-8">
                    <p className="text-small-opacity">{IssueType_text}</p>
                  </div>
                  <div className="col-xs-16">
                    <p>{serviceRequest != null ? serviceRequest.supportTopicName : ''}</p>
                  </div>
                </div>
                <div className="row" style={{ paddingBottom: '15px' }}>
                  <div className="col-xs-8">
                    <p className="text-small-opacity">{opened}</p>
                  </div>
                  <div className="col-xs-16">
                    <p>{this.displayTime(serviceRequest.createdDate)}</p>
                  </div>
                </div>
                <div className="row" style={{ paddingBottom: '15px' }}>
                  <div className="col-xs-8">
                    <p className="text-small-opacity"> {modifiedDate} </p>
                  </div>
                  <div className="col-xs-16">
                    <p> {this.displayTime(serviceRequest.lastModifiedDate)}</p>
                  </div>
                </div>
                {(() => {
                  let templateExists = false;
                  let templateDisplay = [];
                  let templateRows: any[] = [];
                  if (templateData) {
                    templateExists = true;
                    templateRows = Object.keys(templateData);
                    templateExists = !(templateRows.length == 1 && templateRows[0] == Constant.PartnerAccountInfo);
                  }
                  if (templateExists) {
                    for (var i = 0; i < templateRows.length; i++) {
                      //TODO: Align with additional info
                      if (
                        templateRows[i] != Constant.PartnerAccountInfo &&
                        templateRows[i] != Constant.BrowserInfo.browserInfo
                      ) {
                        templateDisplay.push(
                          <div className="row" style={{ paddingBottom: '15px' }}>
                            <div className="col-xs-8">
                              <p className="text-small-opacity"> {templateRows[i]} </p>
                            </div>
                            <div className="col-xs-16">
                              <p>
                                {' '}
                                {this.displayQuestionAnswer(
                                  templateData[templateRows[i]],
                                  typeof templateData[templateRows[i]]
                                )}{' '}
                              </p>
                            </div>
                          </div>
                        );
                      }
                    }
                    return templateDisplay;
                  } else {
                    return (
                      <div className="row" style={{ paddingBottom: '15px' }}>
                        <div className="col-xs-8">
                          <p className="text-small-opacity"> {description} </p>
                        </div>
                        <div className="col-xs-16">
                          <p> {serviceRequest.description} </p>
                        </div>
                      </div>
                    );
                  }
                })()}
              </div>
            </InfoView>
          </div>
          {phoneSupportCard}

          {(!this.isAttachmentEmpty() ||
            (serviceRequest.notes && serviceRequest.notes.length > 0) ||
            (!this.isConfirmationPage() && !this.isTicketClosed(serviceRequest))) && (
            <div className="flexShrink0">
              <InfoView>
                <div style={{ paddingTop: '15px', paddingBottom: '15px', paddingLeft: '24px', paddingRight: '24px' }}>
                  {(!this.isAttachmentEmpty() ||
                    (!this.isTempTicket(serviceRequest) &&
                      !this.isTicketClosed(serviceRequest) &&
                      !this.isConfirmationPage())) && (
                    <div className="row" style={{ paddingBottom: '15px' }}>
                      <div className="col-xs-24">
                        <h3 style={{ fontSize: '18px', fontWeight: 800 }}>
                          {this.isConfirmationPage() ? Attachments_text : attachmentsLabel}
                        </h3>
                        <p className="text-body">{this.isConfirmationPage() ? '' : Attachments_subtext}</p>
                      </div>
                    </div>
                  )}
                  {!this.isAttachmentEmpty() && (
                    <div className="table-responsive">
                      <table id="dataTable" className="table">
                        <tbody>
                          {this.state.attachments.map((fileAttachment: any, index: any) => {
                            // check using index of due to filename returned can sometimes have a \0 character
                            if (
                              fileAttachment &&
                              fileAttachment.fileNameWithoutExtension &&
                              fileAttachment.fileNameWithoutExtension.indexOf(Constant.PartnerSupportDataFileName) != 0
                            ) {
                              return (
                                <tr>
                                  <td className="col-xs-8">{fileAttachment.fileNameWithoutExtension}</td>
                                </tr>
                              );
                            } else {
                              return null;
                            }
                          })}
                        </tbody>
                      </table>
                    </div>
                  )}
                  {!this.isTempTicket(serviceRequest) &&
                    !this.isTicketClosed(serviceRequest) &&
                    !this.isConfirmationPage() && (
                      <div id="pxsupport-upload" className="paddingBottom24">
                        <div className="img-uploader" id="uploader">
                          <div className="block-col no-reqs">
                            <div className="block win-color-bg-20" id="dragdrop">
                              {(() => {
                                if (this.state.attachFileErrorMessage && this.state.attachFileErrorMessage.length > 0) {
                                  return (
                                    <p style={{ color: 'red', marginBottom: '0' }}>
                                      {this.state.attachFileErrorMessage}
                                    </p>
                                  );
                                }
                              })()}
                              {this.getLoader(this.state.showUploadProgress)}
                              <div className="description" id="browseButton">
                                <button className="btn-link" data-toggle="tab">
                                  {DragDropText}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  {((serviceRequest.notes && serviceRequest.notes.length > 0) ||
                    (!this.isTempTicket(serviceRequest) &&
                      !this.isConfirmationPage() &&
                      !this.isTicketClosed(serviceRequest))) && (
                    <div className="row" style={{ paddingBottom: '15px' }}>
                      <div className="col-xs-24">
                        <h3 style={{ fontSize: '18px', fontWeight: 800 }}>{RequestActivityTitle_text}</h3>
                      </div>
                    </div>
                  )}
                  {serviceRequest.notes &&
                    serviceRequest.notes.map((note: Note, i: number) => (
                      <div className="row" style={{ paddingBottom: '15px' }}>
                        <div className="col-xs-16">
                          {!isAzureTicket() && (
                            <label
                              className="text-body win-color-fg-secondary"
                              style={{ textDecorationLine: 'underline' }}
                            >
                              {AddedByText} {note.createdByName} {onText} {this.displayTime(note.createdDate)}
                            </label>
                          )}
                          {isAzureTicket() && (
                            <label
                              className="text-body win-color-fg-secondary"
                              style={{ textDecorationLine: 'underline' }}
                            >
                              {AddedText} {onText} {this.displayTime(note.createdDate)}
                            </label>
                          )}
                        </div>
                        <div className="col-xs-24" style={{ marginLeft: '15px' }}>
                          <CollapsingElementBox HtmlString={note.text} MaxLinesBeforeCollapsing={5} />
                        </div>
                      </div>
                    ))}
                  {!this.isTempTicket(serviceRequest) &&
                    !this.isTicketClosed(serviceRequest) &&
                    !this.isConfirmationPage() && (
                      <div className="row" style={{ paddingBottom: '15px' }}>
                        <div className="col-xs-24">
                          <label> {textAreaLabel} </label>
                        </div>
                        <div className="col-xs-24">
                          <textarea
                            className="ticket-field"
                            rows={4}
                            cols={50}
                            onChange={event => this.handleOnChange(event)}
                            name="note"
                            aria-label={textAreaLabel}
                            maxLength={Constant.MaxDescriptionLength.nonCosmic}
                          ></textarea>
                          {(() => {
                            if (this.state.showAddNoteError) {
                              tracingService.traceEvent(Constant.actionTypes.clientSideProblem, {
                                errorMessage: 'AddNoteError_text',
                              });
                              return <p style={{ color: 'red' }}>{AddNoteError_text}</p>;
                            }
                          })()}
                        </div>
                      </div>
                    )}
                </div>
              </InfoView>
            </div>
          )}
          <div className="paddingBottom24" style={{ marginLeft: '24px', marginRight: '24px' }}>
            {!this.isConfirmationPage() && (
              <button
                className="btn btn-primary"
                onClick={event => {
                  this.updateServiceRequestHandler(event);
                }}
                disabled={this.isSubmitDisabled()}
              >
                {' '}
                {submit}{' '}
              </button>
            )}
            <button
              className={this.isConfirmationPage() ? 'btn btn-primary' : 'btn'}
              style={{ marginLeft: '5px', marginRight: '5px' }}
              onClick={e => this.props.cancelHandler()}
            >
              {this.props.okButtonText ? this.props.okButtonText : cancel}
            </button>
          </div>
        </div>
      )
    );
  }
}
